<template>
    <v-snackbar v-model="show" :color="color" :top="top" :timeout="timeout" class="toast-snackbar">
        <div class="message" v-html="message"></div>
        <v-btn text @click="show = false">{{ $t('schliessen') }}</v-btn>
    </v-snackbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ToastCmp',
    data() {
        return {
            show: false,
            message: '',
            color: 'success',
            timeout: 4000,
            top: true,
        };
    },

    created() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'toast') {
                this.message = state.snackbarContent.message;
                this.color = state.snackbarContent.color || 'success';
                this.timeout =
                    state.snackbarContent.timeout >= 0
                        ? state.snackbarContent.timeout
                        : state.snackbarContent.color === 'error'
                        ? 0
                        : 4000;
                this.show = true;
            }
        });
    },
});
</script>

<style lang="scss">
.toast-snackbar {
    .v-snack__wrapper.error {
        color: var(--error-text-color) !important;
        background-color: var(--error-bg-color) !important;

        .v-btn {
            color: var(--error-text-color);
        }
    }

    .v-snack__wrapper.warning {
        color: var(--warning-text-color) !important;
        background-color: var(--warning-bg-color) !important;

        .v-btn {
            color: var(--warning-text-color);
        }
    }

    .message {
        max-height: calc(100vh - 64px - 8px - 8px);
        overflow-y: auto;
    }
}
</style>
